export default function Accordion() {
  const accordionItems = document.querySelectorAll('.accordion li')

  if (accordionItems.length === 0) return

  accordionItems.forEach((li) => {
    const answer = li.querySelector('.answear')
    const question = li.querySelector('.question')

    if (!answer || !question) return

    question.addEventListener('click', () => {
      accordionItems.forEach((otherLi) => {
        if (otherLi !== li && otherLi.classList.contains('active')) {
          otherLi.classList.remove('active')
          otherLi.style.setProperty('--answear-height', '0px')
        }
      })

      li.classList.toggle('active')

      if (li.classList.contains('active')) {
        const contentHeight = question.scrollHeight + answer.scrollHeight
        li.style.setProperty('--answear-height', `${contentHeight}px`)
      } else {
        li.style.setProperty('--answear-height', '0px')
      }
    })
  })
}
